import React from "react";

import TasksByUserRowCard from "./task";
import { Panel } from "components/panels";
import { useCustomQuery } from "utilities/hookutils";

interface Props {
  config: server.dto.DashboardTasksPerUserPanelConfig
}

const UserTasksPanel = (props: Props) => {
  const query = useCustomQuery({
    queryFn: async () => window.CoreApi.UserTask.ByUser().then(r => r.data),
    queryKey: ["userTasksForDashboard"]
  });

  return (
    <Panel
      title={props.config.headerLabel}
      panelClassName="s1_dashboard-panel"
      hasData={query.data?.data.length > 0}
      isLoading={query.isLoading}
      hasError={query.isError}
    >
      <div className="list-with-gaps line-layout">
        <div className="list-with-gaps-body">
          {query.data?.data.map((task) => (
            <TasksByUserRowCard key={task.user.userId} task={task} />
          ))}
        </div>
      </div>
    </Panel>
  );
};

export default UserTasksPanel;